<template>
	<div>
		<div v-if="this.productIdList && this.productIdList.length > 0">
			
			<div class="flexcenter"
				style="background:white;justify-content:stretch;align-items: start;max-height:500px;overflow:scroll;scroll-snap-type: x mandatory;">

				<ProductCell class="product" v-for="(productId, index) in this.productIdListExisting"
					:key="productId" :rowIndex="index" :productId="productId" :parentTitle="this.title"
					style="min-width:300px;max-width:300px;border:1px solid white;height:auto;scroll-snap-align:center;"
					@showProductDetails="((product) => this.showProductDetails(product))" />

			</div>
		</div>
	</div>
</template>
<script>
import { STORE_COMMIT, STORE_GETTER } from '../../../store/store';
import ProductCell from '../ProductCell.vue';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { routerMixin } from "@/mixins/routerMixin.js";

export default {
	name: "ProductListView",
	components: { ProductCell },
	mixins: [routerMixin],
	props: {
		parentTitle:String,
		productIdList: Array
	},
	data() {
		return {
			testConnectedProductIdList: [],
		};
	},
	computed: {

		title(){
			return this.parentTitle + "\nProductListView"
		},


		product() {

			if (this.productId > 0) {
				return this.$store.state.productStore.data.productList[this.productId]
			}

			return null;

		},

		productTypeSelected() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},

		productIdListExisting(){
			var productIdList = [];

			this.productIdList?.forEach(productId => {

				const product = this.$store.state.productStore.data.productList[productId]; 

				if (product){
					productIdList.push(productId)
				}
				
			});

			return productIdList

		}

		// gå igenom listan och ta bort de som inte finns. 

	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		addConnectedProductId(){
			const list = this.$store.state.productStore.data.productList.filter(product => product != null);

			const product = list[Math.floor(Math.random() * list.length)];

			this.testConnectedProductIdList.push(product?.productId)
		},

		showProductDetails(product) {
			//this.$router.push('/product/' + product.productId + "/" + product.urlKey)

			if (product.pt != this.productTypeSelected.pt){
				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE_BY_PT, product.pt)
			}
			


			this.routerShowProductDetails(product)
		},

	},
	created() {

	}
};
</script>

<style scoped></style>